export const transitions = {
  default: `200ms ease-in-out`,
  slow: `300ms ease-in-out`,
};
